import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const heroReelFadeDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.heroReel,
  componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
  registryBlockKey: REGISTRY_BLOCK.presentation.heroReelFade,
  displayOrder: 1,
  content: {
    eyebrow: loc3('Am Gleis', 'At the rail', 'Tại đường ray'),
    heading: loc3('Senf & Gleis', 'Mustard & Rail', 'Mù tạt & đường ray'),
    subheading: loc3(
      'Currywurst und Beilagen — ruhige Bilder, frisch vom Stand.',
      'Currywurst and sides — quiet frames, fresh from the stand.',
      'Currywurst và món kèm — khung hình yên, tươi từ quầy.',
    ),
    ctaPrimary: loc3('Zur Karte', 'See the menu', 'Xem thực đơn'),
  },
  media: {
    heroImage: '/platform/defaults/heroes/restaurant/imbiss-on-light-01.jpg',
    heroImageSecondary: '/platform/defaults/heroes/restaurant/imbiss-on-light-02.jpg',
    heroImageTertiary: '/platform/defaults/heroes/restaurant/imbiss-on-light-03.jpg',
  },
};
